import {
    OBTENER_DISPOSITIVOS,
    AGREGAR_DISPOSITIVO,
    ELIMINAR_DISPOSITIVO,
    ACTUALIZAR_DISPOSITIVO,
    DISPOSITIVO_ERROR,
    DISPOSITIVO_OK,
    DISPOSITIVO_ACTUAL,
    OBTENER_DISPOSITIVO,
    OBTENER_DISPOSITIVOS_SUPERVISADOS,
    OBTENER_DISPOSITIVOS_POLICIA_SUPERVISADOS
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_DISPOSITIVOS:
            return {
                ...state,
                dispositivos: action.payload
            }
        case OBTENER_DISPOSITIVOS_SUPERVISADOS:
            return{
                ...state,
                dispositivosSupervisados: action.payload
            }
        case OBTENER_DISPOSITIVOS_POLICIA_SUPERVISADOS:
            return{
                ...state,
                dispositivosPoliciaSupervisados: action.payload
            }
        case DISPOSITIVO_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case DISPOSITIVO_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_DISPOSITIVO:
            return {
                ...state,
                dispositivos: [...state.dispositivos, action.payload],
                formulario: false,
                errorformulario: false
            }
        case DISPOSITIVO_ACTUAL:
            return {
                ...state,
                dispositivo: state.dispositivos.find(disp => disp._id === action.payload)
            }
        case ELIMINAR_DISPOSITIVO:
            console.log(state.reload)
            return {
                ...state,
                reload:!(state.reload),
                dispositivos: state.dispositivos.filter(disp => disp._id !== action.payload),
                dispositivo: null
            }
        case ACTUALIZAR_DISPOSITIVO:
            
            return {
                ...state,
                reload:!(state.reload),
                dispositivos: state.dispositivos.map(disp => disp._id === action.payload._id ? action.payload : disp),
                dispositivo: action.payload
            }
        case OBTENER_DISPOSITIVO:
            return {
                ...state,
                dispositivo: action.payload
            }
        default:
            return state;
    }
}